import React, { Component } from "react";

class DropDownMenu extends Component {
  state = {
    DropDownOpen: false,
  };

  componentDidMount() {
    document.addEventListener("mousedown", this.handleClickOutside);
  }

  handleClickOutside = (event) => {
    if (this.wrapperRef && !this.wrapperRef.contains(event.target)) {
      this.setState({ DropDownOpen: false });
      this.props.onClick && this.props.onClick();
    }
  };

  setWrapperRef = (node) => {
    this.wrapperRef = node;
  };

  handleDropdown = () =>
    this.setState(
      { DropDownOpen: !this.state.DropDownOpen },
      () => this.props.onClick && this.props.onClick(this.state.DropDownOpen)
    );

  render() {
    return (
      <div
        ref={this.setWrapperRef}
        className={"dropdown " + this.props.className}
      >
        <button
          className={
            "dropdown-toggle " +
            this.props.BtnClass +
            (!this.props.noBorder && this.state.DropDownOpen
              ? " omni-brc-international-orange"
              : "")
          }
          type="button"
          aria-haspopup="true"
          aria-expanded={this.state.DropDownOpen}
          onClick={(e) => {
            e.stopPropagation();
            this.handleDropdown();
          }}
        >
          <i
            className={
              "icon-omni-ellipse" +
              (this.state.DropDownOpen
                ? " omni-color-international-orange"
                : this.props.iconSwitch
                ? " omni-color-white "
                : "")
            }
          />
        </button>
        <div
          className={"dropdown-menu" + (this.state.DropDownOpen ? " show" : "")}
          onClick={() =>
            this.setState({ DropDownOpen: !this.state.DropDownOpen })
          }
        >
          {this.props.Items.map((item, key) => {
            const { onClick, ...attr } = item.attr;
            return (
              <a
                className="dropdown-item"
                key={key}
                {...attr}
                onClick={(e) => {
                  if (onClick) {
                    onClick(e);
                    e.stopPropagation();
                  }
                  this.setState({ DropDownOpen: false });
                }}
              >
                {item.Text}
              </a>
            );
          })}
        </div>
      </div>
    );
  }
}

export default DropDownMenu;
